import { render, staticRenderFns } from "./AcademicsDashboard.vue?vue&type=template&id=77aa977a&scoped=true&"
import script from "./AcademicsDashboard.vue?vue&type=script&lang=js&"
export * from "./AcademicsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AcademicsDashboard.vue?vue&type=style&index=0&id=77aa977a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa977a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VDivider,VSkeletonLoader,VSnackbar})
